// extracted by mini-css-extract-plugin
export default {"container":"menu_container__CBiMZ","close":"menu_close__qzwln","menu":"menu_menu__p+jB+","opened":"menu_opened__Deuzi"};